// Le préfixe des liens internes de l'observatoire. Vide sur le site : `/o/91477/…` reste
// `/o/91477/…`, et rien ne change pour un visiteur ou un abonné.
//
// Les maquettes « vivantes » de /admin/design montent la VRAIE observatoire (mêmes
// composants, mêmes données) sous `/admin/design/vivant/<direction>` et posent ce préfixe :
// la barre latérale, les cartes de thématique et les renvois des lectures restent alors dans
// la maquette, et l'état actif des liens de la barre latérale continue de fonctionner.
import { createContext, useContext } from 'react'

export const BaseObsCtx = createContext('')

export function useBaseObs(): string {
  return useContext(BaseObsCtx)
}
